import React from 'react';

import PeopleInformation from './PeopleInformation';
import { PERSON_TYPE } from '../../../constants/stringConstants';
import type { PeopleSection } from '../../../models/index';

type Props = {
  section: PeopleSection;
  setSection: (section: PeopleSection) => void;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function PropertyManagerInformation_v2({ section, setSection, setSectionValues }: Props): JSX.Element {
  const maxPeople = 1;

  return (
    <PeopleInformation
      isOptional
      maximumPeople={maxPeople}
      initialPeople={0}
      personType={PERSON_TYPE.PROPERTY_MANAGER}
      setSectionValues={setSectionValues}
      setSection={setSection}
      section={section}
      label="Does the property have a managing agent, such as a property manager?"
      addressLabel="Address"
    />
  );
}

PropertyManagerInformation_v2.description = 'Address field for propertymanager';
